import { Box, Button, Grid, Typography, useMediaQuery } from "@mui/material";
import React from "react";
import {
  addressBtnColor,
  bgColor,
  blackColor,
  blackShade03,
  blackShade06,
  blackShade58,
  blueColor04,
  greenColor17,
  lightGreenColor05,
  mobilePrimary,
  orangeBgColor,
  whiteColor,
  yellowShade03,
} from "../../../configs/styles/muiThemes";
import { GoogleMap, Marker, useLoadScript } from "@react-google-maps/api";

import { getGeoPointApi } from "../../../service/api_calls/BusinessOnboard/BusinessOnboardingAPI";
import { useState } from "react";
import PickLocationBtn from "../../../components/Buttons/PickLocationBtn";
import { getAddressInfoFromLatLong } from "../../../utils/geoLocationHelper";
import PickAddressFromMapModal from "../../../components/PickAddress/PickAddressFromMapModal";
import FormInputBoxWithBorder from "../../../components/Input/FormInputBoxWithBorder";
import NavigationButtons from "../Components/NavigationButtons";
import { isStringNotPresentInArray } from "../../../utils/helper";
import { GOOGLE_MAPS_API_KEY } from "../../../configs/Constants";
import AddressConfirmAlert from "../Components/AddressConfirmAlert";

const MarkerIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="#1C1C1C"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    aria-labelledby="icon-svg-title- icon-svg-desc-"
    role="img"
    class="sc-rbbb40-0 haYhpV"
  >
    <title>loction-pin</title>
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M8.50376 0.135614C5.50502 0.734541 3.10602 3.13025 2.60623 6.12488C2.00648 9.81826 4.00564 13.1123 7.10435 14.3102C8.10393 14.7095 9.00355 15.4082 9.50334 16.4064C9.70326 16.7059 9.80322 17.1052 10.0031 17.4047C10.1031 17.1052 10.303 16.7059 10.5029 16.4064C11.0027 15.4082 11.9023 14.8093 12.9019 14.3102C15.6008 13.2122 17.5 10.517 17.5 7.42255C17.5 2.9306 13.3018 -0.762775 8.50376 0.135614ZM10.0031 10.0179C8.60372 10.0179 7.50418 8.91987 7.50418 7.52237C7.50418 6.12488 8.60372 5.02685 10.0031 5.02685C11.4025 5.02685 12.5021 6.12488 12.5021 7.52237C12.5021 8.91987 11.4025 10.0179 10.0031 10.0179Z"
    ></path>
    <path
      fill="#10847e"
      d="M10.0033 20C11.1074 20 12.0025 19.5531 12.0025 19.0018C12.0025 18.4505 11.1074 18.0036 10.0033 18.0036C8.89921 18.0036 8.00415 18.4505 8.00415 19.0018C8.00415 19.5531 8.89921 20 10.0033 20Z"
    ></path>
  </svg>
);

function AddressInfoForm({
  handleNext,
  handleBack,
  handleSave,
  addressDetails,
  onValueChange,
  setAddressDetails,
  setCurrentPage,
}) {
  const { isLoaded } = useLoadScript({
    googleMapsApiKey: GOOGLE_MAPS_API_KEY, // Replace with your API key
    libraries: ["places"],
  });

  const matches = useMediaQuery((theme) => theme.breakpoints.up("md"));

  const [openMap, setOpenMap] = useState({
    show: false,
    userLat: "",
    userLong: "",
  });

  const [cityDisabled, setCityDisabled] = useState(true);
  const [openAlert, setOpenAlert] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");

  const handlePinChange = async (value) => {
    if (value?.length === 6) {
      const responce = await getGeoPointApi(value);

      const pinCodeErr = isStringNotPresentInArray(
        responce?.results?.[0]?.address_components,
        "postal_code"
      );
      console.log("pinCodeErrpinCodeErr", pinCodeErr);
      if (pinCodeErr) {
        console.log("Hit");
        setAddressDetails({
          ...addressDetails,
          pinCode: value,
          city: "",
          state: "",
          landmark: "",
          address: "",
          errors: {
            ...addressDetails?.errors,
            pinCode: "Invalid pincode",
          },
        });
        return;
      }

      const city = responce?.results?.[0]?.address_components?.[1]?.long_name;

      const state =
        responce?.results?.[0]?.address_components?.[
          responce?.results?.[0]?.address_components?.length - 2
        ]?.long_name;

      if (!city || !state) setCityDisabled(false);

      setAddressDetails({
        ...addressDetails,
        city: city || "",
        state: state || "",
        landmark: "",
        locality: city || "",
        sublocality: "",
        lat: responce?.results?.[0]?.geometry?.location?.lat || "",
        lng: responce?.results?.[0]?.geometry?.location?.lng || "",
        pinCode: value,
        errors: { ...addressDetails?.errors, city: "", state: "", pinCode: "" },
      });

      setOpenMap({
        show: true,
        userLat: responce?.results?.[0]?.geometry?.location?.lat || "",
        userLong: responce?.results?.[0]?.geometry?.location?.lng || "",
      });
    }
  };

  // Get user current location address
  const handleChooseCurrentLocation = () => {
    setOpenMap({
      show: true,
      userLat: localStorage.getItem("lat"),
      userLong: localStorage.getItem("long"),
    });
  };

  // autoFill user selected address from map
  const handlePickLocationConfirm = (userAddress) => {
    if (userAddress) {
      setAddressDetails({
        ...addressDetails,
        city: userAddress?.city || "",
        state: userAddress?.state || "",
        pinCode: userAddress?.postalCode,
        address: userAddress?.address || "",
        lat: userAddress?.lat || "",
        lng: userAddress?.lng || "",
        landmark: userAddress?.locality || "",
        locality: userAddress?.locality || "",
        sublocality: userAddress?.sublocality || "",
        errors: {
          ...addressDetails?.errors,
          city: "",
          state: "",
          pinCode: "",
          address: "",
        },
      });
    }

    setOpenMap({
      show: false,
      userLat: "",
      userLong: "",
    });
  };

  const handleConfirm = () => {
    if (!addressDetails?.address) {
      setErrorMsg("Enter Bldg No, Street, Area");
      return;
    }

    if (!addressDetails?.landmark) {
      setErrorMsg("Enter Landmark");
      return;
    }

    setOpenAlert(true);
  };

  return (
    <Box sx={styles.card}>
      {isLoaded && (
        <Grid container spacing={2}>
          <Grid item xs={12} md={12}>
            <Box
              sx={{
                width: "100%",
                height: { xs: "30vh", md: "40vh" },
                position: "relative",
              }}
            >
              <SelecteAddressInfo
                fullAddress={
                  addressDetails?.fullAddress || addressDetails?.address
                }
                onChange={() => {
                  setCurrentPage("pick-address");
                }}
              />

              <GoogleMap
                center={{
                  lat: addressDetails?.lat - 0.00006,
                  lng: addressDetails?.lng,
                }}
                zoom={20}
                mapContainerStyle={{ width: "100%", height: "100%" }}
                options={{
                  mapTypeControl: false,
                  fullscreenControl: false,
                  streetViewControl: false,
                  zoomControl: false,
                  keyboardShortcuts: false,
                  disableDefaultUI: true,
                  draggable: false,
                }}
              >
                <Marker
                  position={{
                    lat: addressDetails?.lat,
                    lng: addressDetails?.lng,
                  }}
                />
              </GoogleMap>
            </Box>
          </Grid>
          <Grid item xs={12} md={12}>
            <Box
              p={{ xs: "0px 12px 15px 12px", md: "0px 20px 20px 20px" }}
              sx={
                {
                  // height: { xs: "55vh", md: "50vh" },
                  // overflowY: "scroll",
                  // scrollbarWidth: "none",
                  // "&::-webkit-scrollbar": {
                  //   display: "none",
                  // },
                }
              }
            >
              <FormInputBoxWithBorder
                label="Bldg No, Street, Area"
                value={addressDetails?.address}
                onChange={({ target }) => {
                  onValueChange("address", target.value);
                }}
                error={addressDetails?.errors?.address}
                required
              />
              <FormInputBoxWithBorder
                label="Landmark"
                required
                value={addressDetails?.landmark}
                onChange={({ target }) => {
                  onValueChange("landmark", target.value);
                }}
              />
              {errorMsg && (
                <Typography fontSize={11} fontWeight={500} color="red" mt={-1}>
                  {errorMsg}
                </Typography>
              )}
              <NavigationButtons
                // onBackClick={handleBack}
                hideBackBtn
                onNextClick={() => handleConfirm()}
                nextBtnText="CONFIRM & PROCEED"
                nextBtnColor={yellowShade03}
                nextBtnTextColor={blackColor}
              />
            </Box>
          </Grid>
        </Grid>
      )}

      <AddressConfirmAlert
        title="Alert"
        content="Please make sure the below address is accurate as the deliveries will be picked up from this location"
        address={`${addressDetails?.address} ${
          addressDetails?.landmark ? `${addressDetails?.landmark},` : ""
        } ${addressDetails?.city}, ${addressDetails?.state} - ${
          addressDetails?.pinCode
        }`}
        city={addressDetails?.city}
        state={addressDetails?.state}
        pincode={addressDetails?.pinCode}
        isOpen={openAlert}
        onClose={() => {
          setOpenAlert(false);
        }}
        onConfirm={handleNext}
      />

      {/* <PickAddressFromMapModal
        isOpen={openMap.show}
        setIsOpen={setOpenMap}
        onConfirm={handlePickLocationConfirm}
        userLat={openMap.userLat}
        userLong={openMap.userLong}
      />

      <Grid container rowSpacing={{ md: 0.5, xs: 0 }} columnSpacing={3}>
        <Grid item xs={12} md={6}>
          <FormInputBoxWithBorder
            label="PinCode"
            required
            maxLength={6}
            value={addressDetails?.pinCode}
            onChange={({ target }) => {
              const value = target.value.replace(/[a-zA-Z]|[^\w\s]/gi, "");
              onValueChange("pinCode", value);
              if (!cityDisabled) setCityDisabled(true);
              if (value.length >= 6) handlePinChange(value);
            }}
            error={addressDetails?.errors?.pinCode}
          />
        </Grid>
        <Grid item xs={12}>
          <PickLocationBtn
            onChooseLocation={handleChooseCurrentLocation}
            onPickNearLocation={() => {
              setOpenMap(true);
            }}
            bgColor={whiteColor}
            textColor={matches ? blueColor04 : mobilePrimary}
          />
        </Grid>

        <Grid item xs={12} md={6}>
          <FormInputBoxWithBorder
            label="City"
            value={addressDetails?.city}
            onChange={({ target }) => {
              onValueChange("city", target.value);
            }}
            required
            disabled={cityDisabled}
            inputOpaticy={1}
            error={addressDetails?.errors?.city}
          />
        </Grid>

        <Grid item xs={12} md={6}>
          <FormInputBoxWithBorder
            label="State"
            value={addressDetails?.state}
            onChange={({ target }) => {
              onValueChange("state", target.value);
            }}
            required
            disabled={cityDisabled}
            inputOpaticy={1}
            error={addressDetails?.errors?.state}
          />
        </Grid>

        <Grid item xs={12} md={12}>
          <FormInputBoxWithBorder
            label="Bldg No, Street, Area"
            value={addressDetails?.address}
            onChange={({ target }) => {
              onValueChange("address", target.value);
            }}
            error={addressDetails?.errors?.address}
            required
          />
        </Grid>

        <Grid item xs={12} md={12}>
          <FormInputBoxWithBorder
            label="Landmark"
            value={addressDetails?.landmark}
            onChange={({ target }) => {
              onValueChange("landmark", target.value);
            }}
          />
        </Grid>
      </Grid>

      <Box sx={styles.infoBox}>
        <Typography
          textAlign={"center"}
          fontWeight={500}
          fontSize={{ xs: 12, md: 14 }}
          color={blackShade58}
          lineHeight={{ xs: "20px", md: "22px" }}
        >
          Please make sure the above address is accurate as the deliveries will
          be picked up from this location
        </Typography>
      </Box>

      <NavigationButtons
        onBackClick={handleBack}
        onNextClick={() => setOpenAlert(true)}
      /> */}
    </Box>
  );
}

export default AddressInfoForm;

const SelecteAddressInfo = ({ fullAddress, onChange }) => {
  return (
    <Box sx={styles.selectedAddrInfoBox}>
      <Box
        display="flex"
        alignItems="center"
        justifyContent="space-between"
        mb={{ xs: "5px", md: "15px" }}
      >
        <Typography
          fontSize={{ xs: 13.5, md: 14 }}
          fontWeight={600}
          color={blackColor}
          lineHeight="15px"
          letterSpacing="-0.3px"
        >
          Selected Address
        </Typography>

        <Button
          variant="text"
          sx={{
            fontSize: 11.5,
            fontWeight: 600,
            lineHeight: "15px",
            textDecoration: "underline",
            textTransform: "uppercase",
            "&:hover": {
              bgcolor: "transparent",
            },
          }}
          onClick={onChange}
        >
          Pick New Location
        </Button>
      </Box>

      <Box
        sx={{
          display: "flex",
          alignItems: "flex-start",
          gap: "9px",
          bgcolor: lightGreenColor05,
          p: "10px 8px",
          borderRadius: "6px",
        }}
      >
        <Box
          width={{ xs: "19px", md: "21px" }}
          height={{ xs: "19px", md: "21px" }}
          mt={-0.1}
        >
          <MarkerIcon />
        </Box>

        <Typography
          fontSize={{ xs: 11.5, md: 12.5 }}
          fontWeight={600}
          color={greenColor17}
          lineHeight="18px"
          letterSpacing="0px"
        >
          {fullAddress}
        </Typography>
      </Box>
    </Box>
  );
};

const styles = {
  card: {
    // width: { xs: "100%", md: "100%" },
    // mt: { md: "35px", xs: 1.5 },
  },

  headingText: {
    fontSize: { xs: 17, md: 18 },
    color: blackColor,
    fontWeight: 500,
    lineHeight: "30px",
    mb: "10px !important",
  },

  subText: {
    fontSize: { xs: 12, md: 12 },
    color: blackShade03,
    fontWeight: 400,
    lineHeight: { xs: "17px", md: "20px" },
    mb: "15px !important",
  },

  infoBox: {
    px: 3,
    py: 1,
    borderRadius: "7px",
    backgroundColor: orangeBgColor,
    mb: 2,
  },

  selectedAddrInfoBox: {
    width: { xs: "calc(100% - 14px)", md: "calc(100% - 14px)" },
    bgcolor: whiteColor,
    position: "absolute",
    bottom: { xs: 0, md: 0 },
    right: 0,
    zIndex: 10,
    p: { xs: "10px 12px", md: "15px" },
    mr: { xs: "7px", md: "7px" },
    border: `1px solid ${lightGreenColor05}`,
    borderRadius: { xs: "10px 10px 0 0", md: "10px 10px 0px 0px" },
    boxShadow: "rgb(0 0 0 / 17%) 0px -5px 8px 0px",
  },
};
